import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class HeaderOnScroll {
	constructor() {
		this.header = document.querySelector('header')
		if (!this.header) return

		this.#initScrollHeading()
		this.#initBackgroundDetection()
	}

	#initBackgroundDetection() {
		const lightSections = document.querySelectorAll('section.bg-white')
		if (!lightSections.length) return

		this.bgTriggers = Array.from(lightSections).map(section =>
			ScrollTrigger.create({
				trigger: section,
				start: 'top top',
				end: 'bottom top',
				onToggle: self => {
					this.header.classList.toggle('header-light', self.isActive)
				},
			})
		)
	}

	#initScrollHeading() {
		this.directionTrigger = ScrollTrigger.create({
			start: 0,
			end: 'max',
			onUpdate: self => {
				if (self.scroll() < 100) {
					this.header.classList.remove('header-hidden')
					return
				}

				if (self.direction === 1) {
					this.header.classList.add('header-hidden')
				} else if (self.direction === -1) {
					this.header.classList.remove('header-hidden')
				}
			},
		})
	}

	destroy() {
		this.directionTrigger?.kill()
		this.directionTrigger = null
		this.bgTriggers?.forEach(trigger => trigger.kill())
		this.bgTriggers = null
	}
}
